//content varDlgCust
var DynamicForm = new function(){
    var dynamicForm;
    
    this.ShowDynamicFormTest = function(){
      if(dynamicFromContent().length === 0){
        createDynamicForm();
        getDynamicFormData(initDynamicForm);
      }
      
      mainComponent().hide();
      dynamicFromContent().show();
      //scroll top
      window.scrollTo(0, 0);
    };
    
    this.ShowDynamicForm = function(idSelector){
      $(DynamicFromTemplates.dynamic_form).appendTo("#" + idSelector);
      getDynamicFormData(initDynamicForm);
    }
    
    this.GetSelection = function(){
      return _objectWithoutProperties(dynamicForm.output)
    }
    
    
    this.HideDynamicForm = function(){
      mainComponent().show();
      dynamicFromContent().hide();
    };
    
    this.GetForm = function(){
      return dynamicForm;
    }
    
    this.GetSelection = function(){
      return _objectWithoutProperties(dynamicForm.output)
    }
    
    
    function _objectWithoutProperties(obj) {
      var target = {};
      for (var i in obj) {
        if (i.lastIndexOf("_", 0) === 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
      }
      return target;
    }
    
    function createDynamicForm(){
      $(DynamicFromTemplates.dynamic_form_wrap).insertAfter(mainComponent());
    }
    
    
    function mainComponent(){
      return $('.container.main.content');
    }
    
    function dynamicFromContent(){
      return $('.content.varDlgCust');
    }
    
    function getDynamicFormData(callBackFn) {
      var xmlhttp = new XMLHttpRequest();
      xmlhttp.open('GET', '//www.dyefor.com/cdn/shop/t/587/assets/dynamic-form-data.json?v=71831', true);
                   xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState == 4) {
              if (xmlhttp.status == 200) {
                var obj = JSON.parse(xmlhttp.responseText);
                callBackFn(obj);
              }
            }
          };
          xmlhttp.send(null);
        }
      
  
    function initDynamicForm(data){
      if(!dynamicFormSchema || !dynamicFormSchema.length){
        return;
      }  
  
      if(!data){
        return;
      } 
  
      var schema = data[dynamicFormSchema];
      if(!schema){
        return;
      }
  
  
      Vue.component('component-tree', { 
        delimiters: ['£{', '}'],
        template: DynamicFromTemplates.component_tree_template,
        props:{
          schema:Array
        },
        methods:{
        }
      });
  
      Vue.component('select-and-images', { 
        delimiters: ['£{', '}'],
        template: DynamicFromTemplates.select_and_images_template,
        props:{
          schema:Object
        },
        data:function () {
          return {
            visibleImagesData:[],
            selectedImage:""
          }
        },
        methods: {
          onImageselectSelectChanged(event) {
            this.selectedImage="";
            this.visibleImagesData = this.schema.images[event.target.value];
            this.$emit('valuechanged', {name: event.target.name, value: event.target.value});
          },
          getImageUrl(image){
            if(this.schema.imagefolder)
              return this.schema.imagefolder + image;
  
            return image;
          },
          getBackgroudUrl: function(imge){
            return "url('" + this.getImageUrl(imge) + "')";
          },
          selectImage(image){
            this.selectedImage = image;
            this.$emit('valuechanged', {name: this.schema.imageInputName, value: this.getImageUrl(image)});
          },
          getSliderImages(){
             return $("#" + this.schema.name + ' .sliderimages');
          },
          isFlickityActive(){
            return this.getSliderImages().hasClass('flickity-enabled');
          }
        },
        computed:{
            visibleImages: function(){
              if(this.isFlickityActive()){
                this.getSliderImages().flickity('destroy');
              }
              if(this.visibleImagesData && this.visibleImagesData.length){
                return this.visibleImagesData;
              }
  
              return [];
            },
          imageNameAttr:function(){
            return this.schema.name + '-image';
          }
        },
        updated: function () {
          this.$nextTick(function () {
            if(isSmallDevice()){
              this.getSliderImages().addClass('small-device');
              return;
            }else{
              this.getSliderImages().removeClass('small-device');
            }
            
            if((this.visibleImagesData && this.visibleImagesData.length > 7) 
               || (this.schema.useBigIcons && this.visibleImagesData && this.visibleImagesData.length > 4)){
              this.getSliderImages().flickity({pageDots: false, contain: true, cellAlign: 'left' });
            }
          })
        }
  
  
      });
  
  
      dynamicForm = new Vue({
        delimiters: ['£{', '}'],
        el:"#dynamic_ui",
        data : {
          schema: schema,
          output:{}
        },
        computed : {},
        methods:{
          onValueChanged:function(changedNameValue){
            if(changedNameValue.name){
              this.output[changedNameValue.name] = changedNameValue.value;
            }
            
          }
        }
      });
    }
  
    var DynamicFromTemplates = new function(){
      this.component_tree_template = `
            <div>
                <div v-for="item in schema" >
                <label>£{item.label}</label>
                <div v-if="item.fieldType == 'SelectList'">
                    <select :name="item.name" v-model="item.value">
                        <option v-for="option in item.options" :value="option.value">£{option.text}</option>
                    </select>
                </div>
  
                <div v-if="item.fieldType == 'TextInput'">
                    <span class="validationmessage" v-if="item.validationmessage">£{item.validationmessage}</span>
                    <input :name="item.name" :placeholder="item.placeholder" v-model="item.value" type="text" :pattern="item.regex"/>
                </div>
  
                <div v-if="item.fieldType == 'NumberInput'">
                    <input type="number" :placeholder="item.placeholder" :name="item.name" :min="item.minValue" v-model="item.value" >
                </div>
                <div v-if="item.fieldType == 'SelctAndImages'">
                    <select-and-images :schema="item" @valuechanged="$emit('valuechanged', $event)"></select-and-images>
                </div>
              <component-tree :schema="item.schema" @valuechanged="$emit('valuechanged', $event)"></component-tree>
            </div>
        </div>`;
      this.select_and_images_template = `
        <div :id="schema.name">
          <select :name="schema.name" v-model="schema.value" @change="onImageselectSelectChanged($event)">
            <option v-if="schema.placeholder" value="" disabled selected hidden>£{schema.placeholder}</option>
            <option v-for="option in schema.options" :value="option.value">£{option.text}</option>
          </select>
          <div class="sliderimages" :class="{ big_icons : schema.useBigIcons}">
            <div v-if="visibleImages" v-for="image in visibleImages" class="bg-trans" 
                    :class="{ selected: selectedImage == image }"
                    @click="selectImage(image)">
              <div class="bg-image"
                      :style="{ backgroundImage: getBackgroudUrl(image)}"></div>
              </div>
          </div>
        </div>`;
  
      this.dynamic_form_wrap=`<div class="content varDlgCust dynamic_ui_wrap" style="display:none"><div id="dynamic_ui">
            <div class="cst_container cst_inner_container">
            <component-tree :schema="schema" @valuechanged="onValueChanged($event)"></component-tree></div>
            </div>
  
            <div class="row">
                <input type="button" class="hc-trigger" onclick="DynamicForm.HideDynamicForm()" value="Cancel">
                <input type="button" class="btnCstDone" value="preview" style="display: none;">
            </div>
           </div>`;
      this.dynamic_form=`<div id="dynamic_ui"><component-tree :schema="schema" @valuechanged="onValueChanged($event)"></component-tree></div>`
    }
  }